const PresetWindowLevelState = [
  {
    name: "CT Abdomen",
    windowLevel: 60,
    windowWidth: 400
  },
  {
    name: "CT Angio",
    windowLevel: 300,
    windowWidth: 600
  },
  {
    name: "CT Bone",
    windowLevel: 300,
    windowWidth: 1500
  },
  {
    name: "CT Brain",
    windowLevel: 40,
    windowWidth: 80
  },
  {
    name: "CT Chest",
    windowLevel: 40,
    windowWidth: 400
  },
  {
    name: "CT Lungs",
    windowLevel: -400,
    windowWidth: 1500
  }
];

export default PresetWindowLevelState;
